export interface MethodOfPayment {
  type: string;
  activeUrl: string;
  inactiveUrl: string;
}

export interface DaysOfMonth {
  id: number;
  title: string;
}

export interface Frequency {
  id: string;
  title: string;
}

export const FREQUENCY: Frequency[] = [
  {
    title: "Daily",
    id: 'daily'
  },
  {
    id: 'weekly',
    title: "Weekly",
  },
  {
    id: 'monthly',
    title: "Monthly",
  },
];

export const DAYSOFMONTH: DaysOfMonth[]  = [
  {
    id: 1,
    title: "1st",
  },
  {
    id: 2,
    title: "2nd",
  },
  {
    id: 3,
    title: "3rd",
  },
  {
    id: 4,
    title: "4th",
  },
  {
    id: 5,
    title: "5th",
  },
  {
    id: 6,
    title: "6th",
  },
  {
    id: 7,
    title: "7th",
  },
  {
    id: 8,
    title: "8th",
  },
  {
    id: 9,
    title: "9th",
  },
  {
    id: 10,
    title: "10th",
  },
  {
    id: 11,
    title: "11th",
  },
  {
    id: 12,
    title: "12th",
  },
  {
    id: 13,
    title: "13th",
  },
  {
    id: 14,
    title: "14th",
  },
  {
    id: 15,
    title: "15th",
  },
  {
    id: 16,
    title: "16th",
  },
  {
    id: 17,
    title: "17th",
  },
  {
    id: 18,
    title: "18th",
  },
  {
    id: 19,
    title: "19th",
  },
  {
    id: 20,
    title: "20th",
  },
  {
    id: 21,
    title: "21st",
  },
  {
    id: 22,
    title: "22nd",
  },
  {
    id: 23,
    title: "23rd",
  },
  {
    id: 24,
    title: "24th",
  },
  {
    id: 25,
    title: "25th",
  },
  {
    id: 26,
    title: "26th",
  },
  {
    id: 27,
    title: "27th",
  },
  {
    id: 28,
    title: "28th",
  },
  {
    id: 29,
    title: "29th",
  },
  {
    id: 30,
    title: "30th",
  },
  {
    id: 31,
    title: "31st",
  },
]


export const DAYSOFWEEK: string[] = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const METHODOFPAYMENT: MethodOfPayment[] = [
  {
    type: "card",
    activeUrl: "../../../../assets/img/card-pay-selected.svg",
    inactiveUrl: "../../../../assets/img/card-pay-unselected.svg",
  },
  // {
  //   type: "applePay",
  //   activeUrl: "../../../../assets/img/apple-pay-selected.svg",
  //   inactiveUrl: "../../../../assets/img/apple-pay-unselected.svg",
  // },
  // {
  //   type: "googlePay",
  //   activeUrl: "../../../../assets/img/google-pay-selected.svg",
  //   inactiveUrl: "../../../../assets/img/google-pay-unselected.svg",
  // },
];
